"use client";

import Script from "next/script";

import { GAM_DISPLAY_ENABLED, GAM_ENABLED, GAM_WEB_INTERSTITIAL_ENABLED } from "@/components/ads/config";

const GPT_SRC = "https://securepubads.g.doubleclick.net/tag/js/gpt.js";

export default function GptBoot() {
  if (!GAM_ENABLED && !GAM_DISPLAY_ENABLED && !GAM_WEB_INTERSTITIAL_ENABLED) return null;

  return (
    <Script
      id="bfc-gpt"
      src={GPT_SRC}
      strategy="afterInteractive"
      async
      onLoad={() => {
        if (GAM_WEB_INTERSTITIAL_ENABLED && !GAM_ENABLED && !GAM_DISPLAY_ENABLED) return;
        window.googletag = window.googletag || { cmd: [] };
        window.googletag.cmd.push(() => {
          const pubads = window.googletag.pubads();
          const googletagWithConfig = window.googletag as typeof window.googletag & {
            setConfig?: (_config: {
              collapseDiv?: "ON_NO_FILL" | "BEFORE_FETCH" | "DISABLED";
              singleRequest?: boolean;
              lazyLoad?: {
                fetchMarginPercent?: number;
                renderMarginPercent?: number;
                mobileScaling?: number;
              };
            }) => void;
          };

          if (googletagWithConfig.setConfig) {
            googletagWithConfig.setConfig({
              collapseDiv: "ON_NO_FILL",
              singleRequest: true,
              lazyLoad: {
                fetchMarginPercent: 100,
                renderMarginPercent: 25,
                mobileScaling: 1.5,
              },
            });
          } else {
            pubads.collapseEmptyDivs(true);
            pubads.enableSingleRequest();

            if (typeof pubads.enableLazyLoad === "function") {
              pubads.enableLazyLoad({
                fetchMarginPercent: 100,
                renderMarginPercent: 25,
                mobileScaling: 1.5,
              });
            }
          }

          window.googletag.enableServices();
        });
      }}
    />
  );
}
